const attributes = {
  data: {
    type: "object",
    default: { tringle_text: "" },
  },
};

export default attributes;
